import * as React from 'react'
import {connect} from 'react-redux'
import {IStore} from '../../../../interfaces/reducers'
import {IFeatureLayerInfo, IMapPopupProperties} from '../../../../interfaces/models'

import {parseFeatureFields, getFeatureTitle} from '../../../../helpers'
import {IMapDispatcher} from '../../../../interfaces/dispatchers/IMapDispatcher'
import OverlayLoader from '../../../Loading/OverlayLoading'
import {Feature, Extent, FeatureStatus} from '../../../../models'

import {IFeatureLayerInfos} from '../../../../interfaces/reducers'
import {IMapService} from '../../../../interfaces/services'
import {MapPopupService, MapGridCell} from '../../../../services'

const mobileHeight = 300
export interface OwnProps {
  mapExtent: Extent
  popupInfo: IMapPopupProperties
  layerInfos: IFeatureLayerInfos
}

interface ParentProps {
  mapService?: IMapService
  arrowWidth?: number
  arrowHeight?: number
  headerHeight: number
  mapDispatcher: IMapDispatcher
  popupWidth: number
  popupHeight: number
  tools: Array<{onClick: (feature: Feature, layerInfo?: IFeatureLayerInfo) => void; icon: JSX.Element}>
  detailRenderer?: (layerInfo: IFeatureLayerInfo, feature: Feature, popupInfo: IMapPopupProperties) => JSX.Element
  headerRenderer?: (layerInfos: IFeatureLayerInfos, popupInfo: IMapPopupProperties) => JSX.Element
  hideMaximize?: boolean
  centeredPopup?: boolean
}

interface DispatchProps {}

type Props = OwnProps & ParentProps & DispatchProps

const mapGridService = new MapPopupService()
const mapPopupService = new MapPopupService(50, 0, 30, 40)
interface Offsets {
  rotation: string
  arrowColor: string
  arrowLeftOffset: number
  arrowTopOffset: number
  popupLeftOffset: number
  popupTopOffset: number
}

const getOffsets = (mapGridCell: MapGridCell, props: Props): Offsets => {
  const arrowWidth = props.arrowWidth || 30
  const arrowHeight = props.arrowHeight || 15
  let rotation = 'rotate(0deg)'
  let arrowLeftOffset = 0
  let arrowTopOffset = 0
  let popupLeftOffset = 0
  let popupTopOffset = 0
  const arrowColor = '#ff8787'
  // TOP
  if (mapGridCell == MapGridCell.TopLeft) {
    popupLeftOffset -= arrowWidth
    arrowLeftOffset = arrowHeight
    // arrowColor = headerColor;
  } else if (mapGridCell == MapGridCell.TopCenter) {
    arrowLeftOffset = props.popupWidth / 2 - arrowWidth / 2
    popupLeftOffset -= props.popupWidth / 2
    // arrowColor = headerColor;
  } else if (mapGridCell == MapGridCell.TopRight) {
    arrowLeftOffset = props.popupWidth - arrowWidth - arrowHeight
    popupLeftOffset -= props.popupWidth - arrowWidth
    // arrowColor = headerColor;
  }
  // MIDDLE
  else if (mapGridCell == MapGridCell.MiddleCenter) {
    rotation = 'rotate(90deg)'
    arrowTopOffset = props.popupHeight / 2 - arrowHeight / 2
    arrowLeftOffset = props.popupWidth - arrowHeight - arrowHeight / 2 - 1 ////
    popupTopOffset -= props.popupHeight / 2
    popupLeftOffset -= props.popupWidth
  } else if (mapGridCell == MapGridCell.MiddleRight) {
    rotation = 'rotate(90deg)'
    arrowTopOffset = props.popupHeight / 2 - arrowHeight / 2
    arrowLeftOffset = props.popupWidth - arrowHeight - arrowHeight / 2 - 1 ////
    popupTopOffset -= props.popupHeight / 2
    popupLeftOffset -= props.popupWidth
  } else if (mapGridCell == MapGridCell.MiddleLeft) {
    rotation = 'rotate(270deg)'
    arrowTopOffset = props.popupHeight / 2 - arrowHeight / 2
    arrowLeftOffset = -arrowHeight / 2
    popupTopOffset -= props.popupHeight / 2
  }
  // BOTTOM
  else if (mapGridCell == MapGridCell.BottomCenter) {
    rotation = 'rotate(180deg)'
    arrowTopOffset = props.popupHeight - arrowHeight
    arrowLeftOffset = props.popupWidth / 2 - arrowWidth / 2
    popupTopOffset -= props.popupHeight
    popupLeftOffset -= props.popupWidth / 2
  } else if (mapGridCell == MapGridCell.BottomLeft) {
    rotation = 'rotate(180deg)'
    arrowTopOffset = props.popupHeight - arrowHeight
    arrowLeftOffset = arrowHeight
    popupTopOffset -= props.popupHeight
    popupLeftOffset -= arrowWidth
  } else if (mapGridCell == MapGridCell.BottomRight) {
    rotation = 'rotate(180deg)'
    arrowTopOffset = props.popupHeight - arrowHeight
    arrowLeftOffset = props.popupWidth - arrowWidth - arrowHeight
    popupTopOffset -= props.popupHeight
    popupLeftOffset -= props.popupWidth - arrowWidth
  }
  return {
    arrowLeftOffset,
    arrowTopOffset,
    popupLeftOffset,
    popupTopOffset,
    rotation,
    arrowColor
  }
}

const renderFeatureAsTableRows = (labelValues: {[label: string]: string}) => {
  const result: Array<JSX.Element> = []
  let counter = 0
  for (const label in labelValues) {
    counter++
    result.push(
      <tr key={counter}>
        <td>{label}</td>
        <td style={{textAlign: 'right'}}>{labelValues[label]}</td>
      </tr>
    )
  }
  return result
}

const renderPage = (props: Props): JSX.Element => {
  const headerHeight = props.headerHeight
  if (props.popupInfo.error) {
    return (
      <div
        key="page"
        className="simple-popup-page-content"
        style={{
          display: props.popupHeight == mobileHeight ? 'block' : 'block',
          top: `${headerHeight}px`,
          bottom: `${props.tools.length > 0 ? headerHeight : headerHeight}px`
        }}
      >
        {JSON.stringify(props.popupInfo.error)}
      </div>
    )
  }
  if (props.popupInfo.loading) {
    return (
      <div key="page" className="simple-popup-no-data">
        <OverlayLoader size="40px" show={true} />
      </div>
    )
  }
  if (props.popupInfo.data!.length == 0) {
    return (
      <div key="page" className="simple-popup-no-data">
        Няма данни
      </div>
    )
  }

  let featurePair = props.popupInfo.data![0]

  if (props.popupInfo.selectedPage) {
    featurePair = props.popupInfo.data![props.popupInfo.selectedPage]
  }
  if (featurePair.feature.status == FeatureStatus.Deleted) {
    return (
      <div key="page" className="simple-popup-no-data">
        Обектът е изтрит
      </div>
    )
  }

  const featureLayerInfo = props.layerInfos[featurePair.id]
  if (featureLayerInfo && props.popupInfo.data) {
    return (
      <div
        key="page"
        className="simple-popup-page-content"
        style={{
          display: props.popupHeight == mobileHeight ? 'block' : 'block',
          top: `${headerHeight}px`,
          bottom: `${props.tools.length > 0 ? headerHeight : headerHeight}px`
        }}
      >
        {props.detailRenderer ? (
          props.detailRenderer(
            featureLayerInfo,
            props.popupInfo.data[props.popupInfo.selectedPage].feature,
            props.popupInfo
          )
        ) : (
          <div style={{height: '100%', overflow: 'auto'}}>
            <table style={{width: '100%'}}>
              <tbody>{renderFeatureAsTableRows(parseFeatureFields(featurePair.feature, featureLayerInfo, true))}</tbody>
            </table>
          </div>
        )}
      </div>
    )
  } else {
    return <div key="page">Error</div>
  }
}

const getHeaderTools = (props: Props): JSX.Element => {
  return (
    <div className="navigation">
      {props.popupInfo.data && props.popupInfo.data.length > 1 ? (
        <div className="navigation" style={{width: '60px'}}>
          <span
            onClick={() => {
              if (props.popupInfo.selectedPage > 0) {
                props.mapDispatcher.setPopupProperties({
                  ...props.popupInfo,
                  selectedPage: props.popupInfo.selectedPage - 1
                })
              }
            }}
            style={{fontSize: '20px', cursor: 'pointer'}}
          >
            <i className="fas fa-caret-left" />
          </span>
          <span>{(props.popupInfo.selectedPage || 0) + 1}</span>/<span>{props.popupInfo.data.length}</span>
          <span
            onClick={() => {
              if (props.popupInfo.selectedPage < props.popupInfo.data!.length - 1) {
                props.mapDispatcher.setPopupProperties({
                  ...props.popupInfo,
                  selectedPage: props.popupInfo.selectedPage + 1
                })
              }
            }}
            style={{fontSize: '20px', cursor: 'pointer'}}
          >
            <i className="fas fa-caret-right" />
          </span>
        </div>
      ) : null}
      {props.hideMaximize ? null : (
        <span
          style={{cursor: 'pointer', margin: '0px 10px', fontSize: '20px'}}
          onClick={() =>
            props.mapDispatcher.setPopupProperties({...props.popupInfo, maximized: !props.popupInfo.maximized})
          }
        >
          <i className="fas fa-window-restore" />
        </span>
      )}

      <span
        style={{cursor: 'pointer', margin: '0px 10px', fontSize: '20px'}}
        onClick={() => props.mapDispatcher.setPopupProperties({...props.popupInfo, show: false, maximized: false})}
      >
        <i className="fas fa-times" />
      </span>
    </div>
  )
}

const renderHeader = (props: Props): JSX.Element => {
  const headerHeight = props.headerHeight
  const localHeaderHeight = props.popupHeight == mobileHeight ? '100%' : `${headerHeight}px`
  if (props.popupInfo.loading) {
    return <div key="header"></div>
  }
  if (props.popupInfo.data && props.popupInfo.data.length > 0) {
    let featurePair = props.popupInfo.data[0]
    if (props.popupInfo.selectedPage) {
      featurePair = props.popupInfo.data![props.popupInfo.selectedPage]
    }
    const featureLayerInfo = props.layerInfos[featurePair.id]
    if (featureLayerInfo) {
      if (props.headerRenderer) {
        return <div key="popup-header">{props.headerRenderer(props.layerInfos, props.popupInfo)}</div>
      }
      return (
        <div
          key="header"
          className="simple-popup-header"
          style={{height: localHeaderHeight, borderRadius: props.popupHeight == mobileHeight ? '5px' : ''}}
        >
          <span style={{marginLeft: '10px'}} className="popupElapsis">
            {getFeatureTitle(featurePair.feature, featureLayerInfo)}
          </span>
          {getHeaderTools(props)}
        </div>
      )
    } else {
      return <div key="header">Error</div>
    }
  } else {
    return (
      <div key="header" className="simple-popup-header" style={{height: localHeaderHeight}}>
        <span style={{marginLeft: '10px'}}>Няма данни</span>
        {getHeaderTools(props)}
      </div>
    )
  }
}

const renderTools = (props: Props): JSX.Element => {
  const headerHeight = props.headerHeight
  if (props.popupInfo.loading) {
    return <div key="tools"></div>
  }
  if (props.tools.length > 0 && props.popupInfo.data) {
    const tools: Array<JSX.Element> = []
    props.tools.forEach((t, i) => {
      tools.push(
        <div
          key={i}
          onClick={() => {
            t.onClick(
              props.popupInfo.data![props.popupInfo.selectedPage].feature,
              props.layerInfos[props.popupInfo.data![props.popupInfo.selectedPage].id]
            )
          }}
        >
          {t.icon}
        </div>
      )
    })
    return (
      <div key="tools" className="simple-popup-footer" style={{height: `${headerHeight}px`}}>
        {tools}
      </div>
    )
  }
  return <div key="tools"></div>
}

let popupInfo = {}
let cachedArray: Array<JSX.Element>
const getPopupContent = (props: Props) => {
  if (popupInfo != props.popupInfo) {
    const array: Array<JSX.Element> = [renderHeader(props), renderPage(props), renderTools(props)]
    cachedArray = array
    popupInfo = props.popupInfo

    return array
  }

  return cachedArray
}

const getContent = (mapGridCell: MapGridCell, props: Props, pointPixels: number[]): JSX.Element => {
  const mobile = window.innerWidth < 1000 ? true : false
  const top = mobile ? `50%` : `70px`
  const right = mobile ? `0px` : `10px`
  const height = mobile ? `${window.innerHeight / 2 - 50}px` : `${window.innerHeight - 200}px`
  const width = mobile ? `${window.innerWidth - 50}px` : `${props.popupWidth}px`

  const popupHeight = window.innerHeight - 200
  const arrowHeight = props.arrowHeight || 0
  return (
    <div
      className="simple-popup"
      style={{
        display: props.popupInfo.show ? 'flex' : 'none',
        top: top,
        right: right
      }}
    >
      <div style={{width: width, height: height, position: 'relative'}}>
        <div
          className="simple-popup-content"
          style={{
            top: `${arrowHeight}px`,
            left: `${arrowHeight}px`,
            bottom: `${arrowHeight}px`,
            right: `${arrowHeight}px`,
            borderRadius: props.popupHeight == mobileHeight ? '5px' : '',
            backgroundColor: 'white'
          }}
        >
          {getPopupContent(props)}
        </div>
      </div>
    </div>
  )
}

const SimpleMapPopup = (props: Props) => {
  let pointPixels: number[] = [0, 0]
  let gridCell = MapGridCell.MiddleCenter
  let valid = true
  if (props.mapService && props.popupInfo.show) {
    const mapWidth = props.mapService.getWidth()
    const mapHeight = props.mapService.getHeight()
    pointPixels = props.mapService.getPixelsFromCoordinates(props.popupInfo.coordinates)
    valid = pointPixels[0] > 0 && pointPixels[0] < mapWidth && pointPixels[1] > 0 && pointPixels[1] < mapHeight
    if (props.centeredPopup) {
      const moddedProps = {...props, popupHeight: mapHeight - mapHeight * 0.2, popupWidth: mapWidth - 40}
      gridCell = mapGridService.getMapGridCell(pointPixels[1], pointPixels[0], mapWidth, mapHeight)
      return getContent(gridCell, moddedProps, pointPixels)
    }
    if (props.popupInfo.maximized) {
      return <div className="simple-popup-maximized-container">{getPopupContent(props)}</div>
    } else {
      if (valid) {
        if ((mapWidth > props.popupWidth * 1.5 && mapHeight > props.popupHeight * 1.5) || props.popupInfo.maximized) {
          gridCell = mapGridService.getMapGridCell(pointPixels[1], pointPixels[0], mapWidth, mapHeight)
          return getContent(gridCell, props, pointPixels)
        } else {
          gridCell = mapPopupService.getMapGridCell(pointPixels[1], pointPixels[0], mapWidth, mapHeight)
          return getContent(gridCell, {...props, popupHeight: mobileHeight, popupWidth: 300}, pointPixels)
        }
      }
    }
  }
  return null
}

const mapStateToProps = (store: IStore) => {
  return {
    mapExtent: store.map.extent,
    popupInfo: store.map.popup,
    layerInfos: store.layerInfos.featureLayerInfos
  }
}

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {})(SimpleMapPopup)
